// @flow
import * as React from 'react';
import classNames from 'classnames/bind';
import cs from './styles.pcss';

const cx = classNames.bind(cs);

type Props = {
  left?: React.Node,
  right?: React.Node,
  className?: string,
};

function TwoColumnsLayout({
  left,
  right,
  className,
}: Props): React.Element<'div'> {
  return (
    <div className={cx('twoColumnsLayout', className)}>
      <div className={cx('right')}>{right}</div>
      <div className={cx('left')}>{left}</div>
    </div>
  );
}

export default TwoColumnsLayout;
